import React from "react";

import ManageStores from "../../components/ManageStores";
import { BUSINESS_TYPES } from "../../utils/constants";

export default function Museums() {
  return <ManageStores type={BUSINESS_TYPES.MUSEUM} />;
}
